import styled from 'styled-components'

import { helpers } from 'styles'

export const BackgroundCircle = styled.circle`
	fill: transparent;
	stroke: ${helpers.color.spinnerBackground};
	stroke-dasharray: 100;
	stroke-linecap: round;
	transform-origin: 50% 50%;
`
